import { MapType } from '../CommonTypes';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';

export const fetchMaps = async (company: string, siteId: string) => {
  if (process.env.NODE_ENV === 'development') console.log('fetching maps', siteId, company);

  const colRef = query(collection(db, `${company}/${siteId}/maps`), orderBy('order'));

  const results = await getDocs(colRef);

  return results.docs.map(doc => {
    const data = doc.data() as Omit<MapType, 'mapid'>;

    return { ...data } as MapType;
  });
};
